import React from "react";
import Image from "next/image";
import newsImg from "../../public/images/banner/banner-news.png";
import plusImg from "../../public/images/news/plus-icon.png";
import Link from "next/link";
import { URL, URL_SERVER } from "@/constants";

const NewsCard = ({ title, news, image, index, link, id }) => {
  const formatUrlImage = (url) => {
    if (url.startsWith("public/img/")) {
      return `${URL_SERVER}/${url}`;
    }
    return url;
  };

  return (
    <>
      <div
        className={
          index % 2 == 0
            ? `row news-card-wrapper mb--80`
            : `row news-reverse-wrapper mb--80`
        }
      >
        <>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="news-image">
              {/* <p>{id}</p> */}
              <img
                src={formatUrlImage(image ? image : "")}
                alt="news image"
                width={200}
                height={200}
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="news-content">
              <p className="news-desc">{news}</p>
              <div className="title">{title}</div>
              <div className="see-more">
                <Link href={link}>
                  <div className="seemore-btn">
                    <Image
                      src={plusImg}
                      alt="news button"
                      width={20}
                      height={20}
                    />
                  </div>
                </Link>
                <span className="seemore-txt">See More</span>
              </div>
            </div>
          </div>
        </>
      </div>
    </>
  );
};

export default NewsCard;
